import React from "react"
import "./MobileSearchBar.scss"
import FindSearchInput from "../FindSearchInput"
import LocatedInSearchInput from "../LocatedInSearchInput"
import OwnedBySearchInput from "../OwnedBySearchInput"
import PropTypes from "prop-types"

class MobileSearchBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      focusedInput: this.props.searchMode ? "FindSearchInput" : "",
      searchMode: this.props.searchMode,
      isExpanded: this.props.isExpanded,
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.searchView && !props.searchMode) return { isExpanded: false }
    return null
  }

  componentDidUpdate(prevProps, prevState) {
    this.setState((state, props) => {
      if (prevProps.searchMode && !props.searchMode)
        return { searchMode: props.searchMode, focusedInput: "" }
    })
  }

  handleClick = event => {
    this.setState((state, props) => {
      const newState = {}
      if (!state.isExpanded) {
        newState.isExpanded = true
      }
      if (!state.searchMode) {
        newState.searchMode = true
        newState.focusedInput = "FindSearchInput"
        props.onSearchMode()
      }
      return newState
    })
  }

  render() {
    return (
      <div
        className={
          this.state.searchMode
            ? "mobile-search-container expanded"
            : "mobile-search-container collapsed"
        }
      >
        <div className="MobileSearchBar">
          <div
            className={
              this.state.isExpanded
                ? "full-form-view"
                : "full-form-view collapsed"
            }
          >
            <div
              className="form-container"
              onClick={this.handleClick}
              ref={formContainer => {
                this.formContainer = formContainer
              }}
            >
              <div className="keyword">
                <FindSearchInput
                  allAssets={this.props.allAssets}
                  keywords={this.props.searchTerms.keywords}
                  updateKeywords={this.props.updateKeywords}
                />
              </div>
              <div className="location">
                <LocatedInSearchInput
                  units={this.props.units}
                  unitId={this.props.searchTerms.unitId}
                  updateLocation={this.props.updateLocation}
                />
              </div>
              <div className="owner">
                <OwnedBySearchInput
                  updateOwnedBy={this.props.updateOwnedBy}
                  departmentId={this.props.searchTerms.departmentId}
                  departments={this.props.departments}
                />
              </div>
              <div className="button">
                <button
                  className="FindAssets"
                  onClick={this.props.onSubmitButtonClick}
                >
                  <h2>Find Assets</h2>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

MobileSearchBar.propTypes = {
  redirect: PropTypes.func,
  isExpanded: PropTypes.bool,
  onSearchMode: PropTypes.func.isRequired,
  searchMode: PropTypes.bool,
  searchView: PropTypes.bool,
  updateKeywords: PropTypes.func,
  updateOwnedBy: PropTypes.func,
  updateLocation: PropTypes.func,
  onSubmitButtonClick: PropTypes.func,
  searchTerms: PropTypes.shape({
    keywords: PropTypes.string,
    unitId: PropTypes.string,
    departmentId: PropTypes.string,
  }).isRequired,
  allAssets: FindSearchInput.propTypes.allAssets,
  units: LocatedInSearchInput.propTypes.units,
  departments: OwnedBySearchInput.propTypes.departments,
}

MobileSearchBar.defaultProps = {
  isExpanded: false,
  searchMode: false,
  allAssets: [],
  units: [],
  departments: [],
  searchTerms: {
    keywords: "",
    unitId: "",
    departmentId: "",
  },
}

export default MobileSearchBar
